import type { Comment } from "./data";
export interface SavedState {
  playbackVersion: 2;
  liked: string[];
  saved: string[];
  followed: string[];
  collections: string[];
  history: string[];
  comments: Record<string, Comment[]>;
  searches: string[];
  profile: { name: string; bio: string };
  draft: string;
  settings: {
    autoplay: boolean;
    muted: boolean;
    comments: boolean;
    notifications: boolean;
  };
}
export const defaultState: SavedState = {
  playbackVersion: 2,
  liked: [],
  saved: [],
  followed: [],
  collections: [],
  history: [],
  comments: {},
  searches: [],
  profile: { name: "林间晚风", bio: "用镜头记录生活的每一帧 ✨" },
  draft: "",
  settings: {
    autoplay: true,
    muted: true,
    comments: true,
    notifications: true,
  },
};
export const STORAGE_KEY = "frame-video-v1";
export function readState(): SavedState {
  try {
    const s = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (!s || typeof s !== "object") return structuredClone(defaultState);
    const strings = (value: unknown): string[] =>
      Array.isArray(value) ? value.filter((v) => typeof v === "string") : [];
    const comments: Record<string, Comment[]> = {};
    if (s.comments && typeof s.comments === "object")
      for (const [id, value] of Object.entries(s.comments)) {
        if (Array.isArray(value))
          comments[id] = value.filter(
            (c) =>
              c &&
              typeof c.id === "string" &&
              typeof c.user === "string" &&
              typeof c.text === "string" &&
              typeof c.likes === "number" &&
              typeof c.time === "string",
          );
      }
    return {
      ...defaultState,
      liked: strings(s.liked),
      saved: strings(s.saved),
      followed: strings(s.followed),
      collections: strings(s.collections),
      history: strings(s.history),
      searches: strings(s.searches).slice(0, 8),
      comments,
      draft: typeof s.draft === "string" ? s.draft : "",
      profile: {
        name:
          typeof s.profile?.name === "string"
            ? s.profile.name
            : defaultState.profile.name,
        bio:
          typeof s.profile?.bio === "string"
            ? s.profile.bio
            : defaultState.profile.bio,
      },
      settings: {
        autoplay:
          s.playbackVersion === 2 && typeof s.settings?.autoplay === "boolean"
            ? s.settings.autoplay
            : true,
        // Each fresh launch starts silent, even if the previous session enabled sound.
        muted: true,
        comments:
          typeof s.settings?.comments === "boolean"
            ? s.settings.comments
            : true,
        notifications:
          typeof s.settings?.notifications === "boolean"
            ? s.settings.notifications
            : true,
      },
    };
  } catch {
    return structuredClone(defaultState);
  }
}
export const toggleId = (items: string[], id: string) =>
  items.includes(id) ? items.filter((x) => x !== id) : [...items, id];
